import * as React from 'react'
import { useInView } from '../../../../../utils/hooks/hooks/useInView'
import { quoteBlockNestedClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { InviewProps } from '../../blocksState'

export type QuoteBlockNested = {
  index: number
  text: string
  author?: string
  inview?: InviewProps
}

export type QuoteBlockNestedStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  contentClassName: string
  quoteClassName: string
  quoteTextClassName: string
  authorClassName: string
}>

export const QuoteBlockNestedLayout = (props: QuoteBlockNested) => {
  const { author, inview, index, text } = props
  const classes = quoteBlockNestedClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("QuoteBlockNestedLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(quoteBlockNestedClasses, 'innerClassName', 'py-3')}>
        <div className={getClassName(quoteBlockNestedClasses, 'contentClassName', 'text-center')}>
          {text && (
            <blockquote className={getClassName(quoteBlockNestedClasses, 'quoteClassName', '')}>
              <p className={getClassName(quoteBlockNestedClasses, 'quoteTextClassName', 'h4')}>{text}</p>
            </blockquote>
          )}

          {author && (
            <figcaption className={getClassName(quoteBlockNestedClasses, 'authorClassName', 'text-muted')}>
              <cite>{author}</cite>
            </figcaption>
          )}
        </div>
      </div>
    </section>
  )
}
